import {
  Modal,
  Form,
  IFormContext,
}                        from 'rewire-ui';
import DataMutations     from '../graphql/Mutations';
import { notifications } from '../ui/Notifications';

interface IForgotPasswordModelState {
  isComplete: boolean;
}

export class ForgotPasswordModel extends Modal<IForgotPasswordModelState> {
  form: Form;

  constructor() {
    super('', true);
    this.form = Form.create((form: IFormContext) => ({
      email: form.email().label('Email').validators('required').placeholder('enter your email').autoFocus(),
    }));
    this.action('submit', this.submit, {type: 'submit'});
  }

  get isComplete(): boolean {
    return this.state.isComplete;
  }

  reset() {
    this.form.reset();
    this.state.isComplete = false;
  }

  load() {
    this.reset();
  }

  private sendEmail = async (): Promise<boolean> => {
    // check email exists in worksight, if not, error notification "that email does not exist in our records" and return false. Otherwise, attempt to send email. Can't do this currently because a lookup
    // requires authentication. Would need a separate unauth email exists call.
    const result = await DataMutations.forgotPassword(this.form.field.email.value);
    if (result) {
      notifications.success('Forgot Password Email Sent');
      this.state.isComplete = true;
      return true;
    }

    notifications.error('Forgot Password Error');
    return false;
  };

  submit = async () => {
    await this.form.submitAsync(this.sendEmail);
    return false;
  };
}

const forgotPasswordModel = new ForgotPasswordModel();
export default forgotPasswordModel;
